function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M14.167 16.667h4.166l-1.17-1.171a1.693 1.693 0 01-.496-1.197v-2.632a5.002 5.002 0 00-3.334-4.716v-.284a1.667 1.667 0 10-3.333 0v.284a5.002 5.002 0 00-3.333 4.716v2.632c0 .449-.179.88-.496 1.197L5 16.666h4.167m5 0v.834a2.5 2.5 0 01-5 0v-.833m5 0h-5",
  stroke: "#FF6C0E",
  strokeWidth: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref2 = /*#__PURE__*/React.createElement("circle", {
  cx: 17,
  cy: 8.833,
  r: 3.333,
  fill: "#0098FF"
});

function SvgBellNotif(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref, _ref2);
}

export default __webpack_public_path__ + "/img/bell_notif.svg";
export { SvgBellNotif as ReactComponent };